import { render, staticRenderFns } from "./MetaFieldConfigButton.vue?vue&type=template&id=631c9c41&scoped=true&"
import script from "./MetaFieldConfigButton.vue?vue&type=script&lang=js&"
export * from "./MetaFieldConfigButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631c9c41",
  null
  
)

export default component.exports